import { useState, useEffect } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import Styles from './Transcript.module.scss'

export const Transcript = ({ transcriptData, playerRef, isInteractive = true }) => {

    const [currentPosition, setCurrentPosition] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const isHighlighted = (word, index) => {
        return currentPosition >= word?.Offset && currentPosition < word?.Offset + word.Duration;
    };

    const isMatched = (word) => {
        return searchQuery && word?.Word.toLowerCase().includes(searchQuery.toLowerCase());
    };

    useEffect(() => {
        const interval = setInterval(() => {
            if (playerRef?.current) {
                const currentTime = Math.floor(playerRef?.current?.getCurrentTime() * 10000000);
                setCurrentPosition(currentTime);
            }
        }, 100); // Update every 100 milliseconds
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPosition]);

    const handleWordClick = (time) => {
        if (playerRef?.current && isInteractive) {
            playerRef?.current.seekTo(time / 10000000);
        }
    };

    return (
        <div>
            <div id='transcriptContainer' className={Styles.transcriptContainer}>
                {transcriptData?.length > 0 ? (
                    <>
                        <span id='transcriptSearch' className={Styles.transcriptSearch}>
                            <TextField
                                variant="outlined"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                fullWidth
                                placeholder='Search'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search fontSize='small' />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </span>

                        <div id='transcriptTextContainer' className={Styles.transcriptTextContainer}>
                            {transcriptData?.map((word, index) => (
                                <span
                                    id='transcriptWord'
                                    key={index}
                                    onClick={() => handleWordClick(word?.Offset)}
                                    className={Styles.transcriptWord}
                                    style={{
                                        cursor: isInteractive ? 'pointer' : 'default',
                                        backgroundColor: isHighlighted(word) ?
                                            'yellow'
                                            : isMatched(word) ? 'lightblue' : '',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (isInteractive) {
                                            e.target.style.textDecoration = 'underline';
                                            e.target.style.color = 'blue';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (isInteractive) {
                                            e.target.style.textDecoration = 'none';
                                            e.target.style.color = 'inherit';
                                        }
                                    }}
                                >
                                    {word?.Word}{' '}
                                </span>
                            ))}
                        </div>
                    </>
                ) : (
                    <div
                        id='noTranscript'
                        className={Styles.noTranscript}
                    >
                        No transcript available for current video.
                    </div>
                )}
            </div>
        </div>
    );
};
